import { Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";
import FormikDropdown from "src/components/Common/UI/Formik/FormkDropdown";
import { useGetAllPlacesList } from "../../Parameters/Geographicals/Places/api/getAllPlacesList";
import { ISearchDropdown } from "src/components/Common/UI/MultipleSelectBox/MultipleSelectBoxFormik";
import FormikReactSelect from "src/components/Common/UI/Formik/FormikSelect";


const UnitsSearchForm = ({ initialValues, onSubmit, onClearForm }: UnitsSearchFormProps) => {
  const { t } = useTranslation();
  const getAllPlacesListQuery = useGetAllPlacesList();
  const placeList = getAllPlacesListQuery.data?.map(place => ({
    value: place.id,
    label: place.name,
  })) || [];

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values, formikHelpers);
      }}
    >
      {({ isSubmitting, resetForm }) => (
        <Form>
          <Container fluid className="p-0">
            <Row> 
              <Col xs={6}>
                <FormikTextbox 
                  label={"Περιγραφή"} 
                  fieldName={"description"}
                />
              </Col>

              <Col xs={6}>
                <FormikTextbox
                  label={"Κωδικός SAP"}
                  fieldName={"sapCode"}
                />
              </Col>

              <Col xs={6}>
                <FormikTextbox 
                  label={"Κωδικός μονάδας"} 
                  fieldName={"unID"}
                />
              </Col>

                
              {/* <Col xs={6}>
                <FormikDropdown 
                  label={t("Tοποθεσία")} 
                  fieldName={"placeID"}
                >
                  <option value="">{t("Επιλέξτε Τοποθεσία")}</option>
                  {getAllPlacesListQuery.data &&
                    getAllPlacesListQuery.data.map((place) => (
                      <option key={place.id} value={place.id}>
                        {place.name}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col> */}

              <Col xs={6}>
                <FormikReactSelect
                  label="Τοποθεσία"
                  fieldName="placeID"
                  options={placeList}
                  placeholder="Επιλέξτε Τοποθεσία"
                />
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Διαγραμμένες")} 
                  fieldName={"deleted"}
                >
                  <option value="">{t("Όχι")}</option>
                  <option value="true">{t("Ναι")}</option>
                </FormikDropdown>
              </Col>
              
            </Row>

            <Row className="row justify-content-end">
              <Col xs="2" className="m-2 me-0">
                <Button
                  type="button"
                  size="sm"
                  color="warning"
                  disabled={isSubmitting}
                  onClick={onClearForm}
                >
                  {t("Καθαρισμός")}
                </Button>
              </Col>

              <Col xs="2" className="m-2">
                <Button
                  type="submit"
                  size="sm"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {t("Αναζήτηση")}
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  )
}

export default UnitsSearchForm;

type UnitsSearchFormProps = {
  initialValues: IUnitSearchForm;
  onSubmit: (
    values: IUnitSearchForm,
    formikHelpers: FormikHelpers<IUnitSearchForm>
  ) => void;
  onClearForm: () => void;
}